import React, {useRef, useEffect, useState} from 'react'
import ReactPlayer from 'react-player/lazy'
import BannerSound from '../icons/BannerSound.svg'
import SoundOff from '../icons/SoundOff.svg'
import { getVideosForBanner } from '../../actions/videoActions';
import { useSelector, useDispatch} from 'react-redux';


function Banner() {

    const bannerPlayerRef = useRef()

    const dispatch = useDispatch()

    const [muted, setMuted] = useState(true)

    const {videosForBanner} = useSelector(state => state.videosForBanner)  

    useEffect(()=>{
        if (!videosForBanner || !videosForBanner.id){
            dispatch(getVideosForBanner(194))
        }
    },[dispatch])

    return (
        <div id="banner_wrapper">
            {
                videosForBanner &&

                <ReactPlayer
                    ref = {bannerPlayerRef} 
                    className='react-player shrinked'    
                    url = {videosForBanner.scripted_bunny_path}
                    playing = {true}
                    muted = {muted}
                    config={{
                    file: { 
                        attributes: {
                        controlsList: 'nodownload noprops.fullscreen'
                        }
                    }
                    }}
                    width="100%"
                    height='100%'
                />  
            }
            {
                videosForBanner && videosForBanner.title ?
                <div className = 'col-12 px-2 px-md-5 pb-1 pb-md-5 d-flex align-items-end position-absolute' style={{bottom:'15vw', zIndex:500}}>
                    <div className='text-white ps-0 ps-md-4 fw-light pe-4 ' id = 'banner_title' >
                        {videosForBanner.title.toUpperCase()}
                        <span>
                            {
                                muted ? 
                                <img 
                                    src = {SoundOff} 
                                    role = 'button'
                                    className='ps-4'
                                    onClick={()=>setMuted(false)}
                                    alt = ''/> :
                                <img 
                                    src = {BannerSound} 
                                    role = 'button'
                                    className='ps-4'
                                    onClick={()=>setMuted(true)}
                                    alt = ''/>
                            }

                        </span>
                    </div>
                </div> :""
            }

        </div>
    );
}

export default Banner;